import { createFileRoute, Outlet } from "@tanstack/react-router";

import React from "react";
import { useTranslation } from "react-i18next";
import TabLayout from "src/components/base/tab-layout";
import { Tab, TabMenu } from "src/components/base/tab-menu";

/**
 * The properties for {@link SettingsLayout}
 */
export type SettingsLayoutProps = {};

/**
 * The layout for the settings section
 */
function SettingsLayout(props: SettingsLayoutProps) {
    const [t] = useTranslation("admin-settings");

    return (
        <TabLayout
            heading={t("heading.settings")}
            tabs={
                <TabMenu>
                    <Tab href={"/a/settings/general"}>{t("label.general")}</Tab>
                    <Tab href={"/a/settings/ldap"}>{t("label.ldap")}</Tab>
                    <Tab href={"/a/settings/oidc"}>{t("label.oidc")}</Tab>
                    <Tab href={"/a/settings/scim"}>{t("label.scim")}</Tab>
                </TabMenu>
            }
        >
            <Outlet />
        </TabLayout>
    );
}

export const Route = createFileRoute("/_admin/a/settings/_settings")({
    component: SettingsLayout,
});
